module.exports = __webpack_public_path__ + "img/zizhi7.fedcccba.png";